import { SocieteCaracteristiqueChoixWithFileName, SocieteComposant } from '@get/api-interfaces';

export function isIconPresent(possibilities: Partial<SocieteCaracteristiqueChoixWithFileName>[]) {
  return possibilities?.some(possibility => !!possibility.fichier);
}

export function isIconPresentInSocieteComposants(societeComposants: Partial<SocieteComposant>[]) {
  return societeComposants?.some(el => !!el.fichier);
}
